export default "__VITE_ASSET__DnDXeqMD__"